import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { useGetAllMyLeafsLazyQuery } from '@school_ify/schoolify-repository/src/teacher/types';
import { useGetMyAssignmentsQuery } from '@school_ify/schoolify-repository/src/student/types';

import { getUser } from 'redux/authentication/auth.slice';
import { useAppSelector } from 'redux/hooks';
import Card from 'components/Card/Card';

import '../../Study/Study.scoped.scss';
import { studyDetailsState } from 'redux/study/studyDetails.slice';

import Chapter from '../../Study/components/ChaptersList/components/Chapter/Chapter';

const SubjectChapters: React.FC<{ parentId: string }> = ({ parentId }) => {
  const user = useAppSelector(getUser);
  const [studyList, setStudyList] = useState(null);
  const { t } = useTranslation('study');

  const {
    data: studyData,
    loading: studyLoading,
    refetch: studyRefach,
  } = useGetMyAssignmentsQuery();

  const [getAllMyLeafs, { data, loading }] = useGetAllMyLeafsLazyQuery();
  const { subjectIsUpdated } = useAppSelector(studyDetailsState);

  useEffect(() => {
    getAllMyLeafs({
      variables: {
        teaching_structure_id: parentId,
      },
    });
  }, []);

  useEffect(() => {
    studyRefach();
  }, [subjectIsUpdated]);

  useEffect(() => {
    if (loading) {
      return;
    }
    studyRefach({
      user_id: user.id,
      teaching_structure_id: data?.teaching_structure_leafs?.map(obj => obj.id),
    });
  }, [data]);

  useEffect(() => {
    if (studyLoading) {
      return;
    }
    setStudyList(_.groupBy(studyData.assignments, obj => obj.teaching_structure.title));
  }, [studyData]);

  const calculatePercentage = obj => {
    const completedAssignments = obj.filter(item => {
      return item.assignment_submits.length && item.assignment_submits[0].is_submited;
    });

    return parseInt(String((completedAssignments.length / obj.length) * 100), 10);
  };

  return (
    <Card>
      <div>
        <Card.Header>
          <div className={'card-header flex justify-between w-100'}>
            <h3>{t('Subject Chapters')}</h3>
          </div>
        </Card.Header>
        <Card.Body>
          {studyList &&
            Object.keys(studyList).map((obj, key) => {
              return (
                <Chapter
                  chapter={studyList[obj]}
                  title={obj}
                  key={key}
                  percentage={calculatePercentage(studyList[obj])}
                />
              );
            })}
        </Card.Body>
      </div>
    </Card>
  );
};

export default SubjectChapters;
